import React from 'react'
import PropTypes from 'prop-types';
import { Steps, Icon } from 'antd';
import styled from 'styled-components'
import constants from '../../config/constants'

const { Step } = Steps;

const DotSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 200 200">
    <path d="M86,14.33333c-39.58041,0 -71.66667,32.08626 -71.66667,71.66667c0,39.58041 32.08626,71.66667 71.66667,71.66667c39.58041,0 71.66667,-32.08626 71.66667,-71.66667c0,-39.58041 -32.08626,-71.66667 -71.66667,-71.66667z"></path>
  </svg>
);

const StyledCheckCircleIcon = styled(Icon)`
  font-size: 20px;
  margin-left: .2rem;
`

const StyledDotIcon = styled(Icon)`
  font-size: 15px;
  margin-left: .4rem;
`

const StyleSteps = styled(Steps)`
  margin-top: 1rem !important;
  width: 90%;
  margin: 0 auto;

  .ant-steps-item-title {
    font-family: 'Thonburi';
    color: ${constants.color.dark} !important;
    width: 100%;
  }
  .ant-steps-item-tail {
    padding: 10px 0 0 !important;
    margin: 10px 0 !important;
  }
  .ant-steps-item-tail::after {
    width: 2.5px !important;
  }

  .ant-steps-item-content {
    min-height: 70px !important;
    margin-left: 3rem !important;

    .ant-steps-item-title {
      margin-top: 0.2rem;
      padding-right: 0 !important;
    }
  }

  .ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon,
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${constants.color.green} !important;
  }

  .ant-steps-item-wait .ant-steps-icon {
    color: ${constants.color.lightGrey1} !important;
  }

  .ant-steps-item-wait .ant-steps-item-tail::after {
    color: ${constants.color.lightGrey1} !important;
  }

  .ant-steps-item-process .ant-steps-item-tail::after {
    color: ${constants.color.lightGrey1} !important;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: ${constants.color.darkBlue} !important;
  }
`

const DotIcon = <StyledDotIcon component={DotSvg}/>
const CheckCircleIcon = <StyledCheckCircleIcon type="check-circle" theme="filled" />

// status => wait' ,'process' ,'finish'

const StepsComponent = (props) => {
  switch (props.current) {
    case 1:
      return (
        <StyleSteps size="small" labelPlacement="vertical" direction="vertical">
          <Step status={'process'} title="ยืนยันตัวตนที่ 7-Eleven" icon={CheckCircleIcon} />
          <Step title="สมัครกองทุน" icon={DotIcon} />
          <Step title="แนบเอกสารประกอบการสมัคร" icon={DotIcon} />
          <Step title="ตรวจสอบความเสี่ยงในการลงทุน" icon={DotIcon} />
        </StyleSteps>
      )
    case 2:
      return (
        <StyleSteps size="small" labelPlacement="vertical" direction="vertical">
          <Step status={'finish'} title="ยืนยันตัวตนที่ 7-Eleven" icon={CheckCircleIcon} />
          <Step status={'process'} title="สมัครกองทุน" icon={CheckCircleIcon} />
          <Step title="แนบเอกสารประกอบการสมัคร" icon={DotIcon} />
          <Step title="ตรวจสอบความเสี่ยงในการลงทุน" icon={DotIcon} />
        </StyleSteps>
      )
    case 3:
      return (
        <StyleSteps size="small" labelPlacement="vertical" direction="vertical">
          <Step status={'finish'}  title="ยืนยันตัวตนที่ 7-Eleven" icon={CheckCircleIcon} />
          <Step status={'finish'}  title="สมัครกองทุน" icon={CheckCircleIcon} />
          <Step status={'process'} title="แนบเอกสารประกอบการสมัคร" icon={CheckCircleIcon} />
          <Step title="ตรวจสอบความเสี่ยงในการลงทุน" icon={DotIcon} />
        </StyleSteps>
      )
    case 4:
      return (
        <StyleSteps size="small" labelPlacement="vertical" direction="vertical">
          <Step status={'finish'} title="ยืนยันตัวตนที่ 7-Eleven" icon={CheckCircleIcon} />
          <Step status={'finish'} title="สมัครกองทุน" icon={CheckCircleIcon} />
          <Step status={'finish'} title="แนบเอกสารประกอบการสมัคร" icon={CheckCircleIcon} />
          <Step status={'finish'} title="ตรวจสอบความเสี่ยงในการลงทุน" icon={CheckCircleIcon} />
        </StyleSteps>
      )
    default:
      return (
        <StyleSteps size="small" labelPlacement="vertical" direction="vertical">
          <Step status={'wait'} title="ยืนยันตัวตนที่ 7-Eleven" icon={DotIcon} />
          <Step title="สมัครกองทุน" icon={DotIcon} />
          <Step title="แนบเอกสารประกอบการสมัคร" icon={DotIcon} />
          <Step title="ตรวจสอบความเสี่ยงในการลงทุน" icon={DotIcon} />
        </StyleSteps>
      )
  }
}

StepsComponent.propTypes = {
  current: PropTypes.number,
};

StepsComponent.defaultProps = {
  current: 0
};

export default StepsComponent



